"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _credits = _interopRequireDefault(require("./credits.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Credits = function Credits(_ref) {
  var children = _ref.children,
      _ref$theme$linkColor = _ref.theme.linkColor,
      linkColor = _ref$theme$linkColor === void 0 ? 'red' : _ref$theme$linkColor;
  return _react["default"].createElement("div", {
    className: _credits["default"]['credits']
  }, _react["default"].createElement("span", null, "Created with"), _react["default"].createElement("a", {
    href: "https://farism.github.io/stylegator",
    target: "_blank",
    style: {
      color: linkColor
    }
  }, "Stylegator"));
};

Credits.propTypes = {};
Credits.defaultProps = {};
var _default = Credits;
exports["default"] = _default;